/** Initials avatar. A photo arrives when NusaIOS exposes one; initials are never placeholder art. */
export function Avatar({ name, size = 40 }: { name: string; size?: number }) {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("");
  return (
    <span
      aria-hidden="true"
      className="inline-flex shrink-0 items-center justify-center rounded-full border border-line bg-elevated text-[13px] font-semibold text-ink"
      style={{ width: size, height: size }}
    >
      {initials}
    </span>
  );
}
